<template>
  <dx-scroll-view height="100%" width="100%" class="with-footer single-card">
     <div class="dx-card"><slot />
     </div>     
  </dx-scroll-view>
</template>

<script>
import DxScrollView from "devextreme-vue/scroll-view";
import PrivacyPolicyLink from "../../src/components/privacy-policy-link";
import {DxButton} from 'devextreme-vue';
import PrivacyPolicyPopup from '../components/privacy-policy.vue';

export default {
  components: {
    DxScrollView,
    PrivacyPolicyLink,
    DxButton,
    PrivacyPolicyPopup,
  },

  methods:{
      btnPrivacyPolicyClick(e){
        //Show the Privacy Policy
        this.$refs.privacyPolicyPopupRef.$data.privacyPolicyVisibleYN = true;
    },
  }
};
</script>

<style lang="scss">
.single-card {

  .dx-card {
    width: 380px;
    margin: auto auto;
    padding: 20px;

    .screen-x-small & {
      width: 100%;
      height: 100%;
      border-radius: 0;
      box-shadow: none;
      margin: 0;
      border: 0;
      flex-grow: 1;
    }
  }
}

</style>
